import { NgForm } from "@angular/forms";

export interface HttpBackendResponse {
    code: number;
    data: any;
    severity?: 'error' | 'warning' | 'info' | 'success';
}

export function isHttpBackendResponse(obj: any): obj is HttpBackendResponse {
    return obj
        && typeof obj === 'object'
        && (Object.keys(obj).length === 2 || Object.keys(obj).length === 3)
        && 'code' in obj
        && 'data' in obj;
}

export interface AuthData {
    username?: string;
    password?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    gender?: string;
    consents?: any
}

export interface ProfileDataSection {
    id: string;
    title: string;
    icon: string;
    cards: ProfileCard[];
}

export interface ProfileCard {
    title: string;
    subtitle?: string;
    originalData: any;
    data: any;
    isEditing: boolean;
    isLoading?: boolean;
    templateName: string;
    template?: any;
    getEndpoint?: string;
    getParameters?: any;
    updateEndpoint: string;
    updateTransform?: (data: any) => any;
    validatorFn?: (data: any) => boolean;
    afterUpdate?: (newData: any, response?: any) => any;
    afterUpdateOverride?: boolean;
    form?: NgForm;
    showFormButtons?: boolean;
}

export interface SettingsSection {
    id: string;
    title: string;
    icon: string;
    cards: SettingsCard[];
}

export interface SettingsCard {
    title: string;
    subtitle?: string;
    originalData: any;
    data: any;
    isEditing: boolean;
    isLoading?: boolean;
    templateName: string;
    template?: any;
    getEndpoint?: string;
    getParameters?: any;
    updateEndpoint?: string;
    updateFunction?: (data: any, successCb: () => any, errorCb: () => any) => any;
    updateTransform?: (data: any) => any;
    validatorFn?: (data: any) => boolean;
    afterUpdate?: (newData: any, response?: any) => any;
    afterUpdateOverride?: boolean;
    form?: NgForm;
    showFormButtons?: boolean;
}